import React from "react";

export const ThankSection = (props) => {
  return (
    <section style={{ display: props.ThankShow ? "block" : "none" }}>
      <div className="container">
        <h1 className="heading_text mt-5">
          رائع {props.userName} الآن لدينا جميع التفاصيل سوف نقوم بالتواصل
          معك لتحديد موعد الاستشارة
        </h1>
      </div>
    </section>
  );
};
